export enum StatisticianGrade {
  level0 = 0,
  level1 = 1,
  level2 = 2,
  level3 = 3,
  level4 = 4,
}

export namespace StatisticianGrade {
  export function all(): StatisticianGrade[] {
    return [
      StatisticianGrade.level0,
      StatisticianGrade.level1,
      StatisticianGrade.level2,
      StatisticianGrade.level3,
      StatisticianGrade.level4,
    ];
  }

  export function toShortString(grade: StatisticianGrade): string {
    switch (grade) {
      case StatisticianGrade.level0:
        return "UG";
      case StatisticianGrade.level1:
        return "L1";
      case StatisticianGrade.level2:
        return "L2";
      case StatisticianGrade.level3:
        return "L3";
      case StatisticianGrade.level4:
        return "L4";
      default:
        return "-";
    }
  }
}
